import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import {
  AVAILABILITY_REMINDER_MESSAGE,
  AVAILABILITY_TAB_QUERY_PARAM,
  AVAILABILITY_TAB_QUERY_VALUE
} from '../../services/availability-reminder.constants';

@Component({
  selector: 'app-availability-reminder-dialog',
  templateUrl: './availability-reminder-dialog.component.html',
  styleUrls: ['./availability-reminder-dialog.component.css']
})
export class AvailabilityReminderDialogComponent {
  readonly message = AVAILABILITY_REMINDER_MESSAGE;

  constructor(
    private dialogRef: MatDialogRef<AvailabilityReminderDialogComponent>,
    private router: Router
  ) {}

  dismiss(): void {
    this.dialogRef.close();
  }

  takeMeToAvailability(): void {
    this.dialogRef.close();
    void this.router.navigate(['/my-profile'], {
      queryParams: {
        [AVAILABILITY_TAB_QUERY_PARAM]: AVAILABILITY_TAB_QUERY_VALUE
      }
    });
  }
}
